import { render, staticRenderFns } from "./SfNotification.vue?vue&type=template&id=6a7031cd"
import script from "./SfNotification.vue?vue&type=script&lang=js"
export * from "./SfNotification.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfNotification.vue?vue&type=style&index=0&id=6a7031cd&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "06e298aa"
  
)

export default component.exports